export default __webpack_public_path__ + "static/media/sports5.e829efb9.jpg";